var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103px",
    height: "83px",
    viewBox: "0 0 103 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maleprofile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AP-Verifications---3-Copy-2",
    transform: "translate(-565.000000, -166.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(167.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(387.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maleprofile",
    transform: "translate(12.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2375",
    x: 0,
    y: 0,
    width: 101,
    height: 81
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(18.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7941176,16.4861246 L13.7941176,6.55416272 C13.7941176,2.9343986 16.7243972,0 20.3485874,0 L49.4166667,0 L49.4166667,16.5211154 C51.4580869,16.913561 53,18.7047125 53,20.8642052 L53,22.1357948 C53,24.3064831 51.4311642,26.1119517 49.3697748,26.4872186 C48.7029121,35.7182504 41.0062883,43 31.6053922,43 C22.2179241,43 14.5266709,35.7374123 13.8434716,26.5209008 C11.6743354,26.2364468 10,24.3861083 10,22.1357948 L10,20.8642052 C10,18.6363424 11.6525685,16.7931919 13.7941176,16.4861246 Z",
    id: "Rectangle-2323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0213816,43 L19.7993421,51.5909091 L9.74804664,51.5909091 C4.58987028,51.5909091 0,55.9164699 0,61 L0,69.1 M65,70 L65,60.7954545 C65,55.7222684 60.827108,51.5909091 55.6795849,51.5909091 L44.3865132,51.5909091 L40.1644737,43",
    id: "Rectangle-2326"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.64e22018a983520ec199e02d38f4fc91.svg";
export { ForwardRef as ReactComponent };